import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, Box, Typography, IconButton, Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PdfFrame from './PdfFrame';

/**
 * Modal de visualização de relatório em PDF. Recebe um blob URL já pronto e o
 * exibe via PdfFrame, com ações de baixar e abrir em nova guia.
 */
export default function RelatorioModal({ open, onClose, titulo, blobUrl, nomeArquivo, loading = false, error = null }) {
    const baixar = () => {
        if (!blobUrl) return;
        const link = document.createElement('a');
        link.href = blobUrl;
        // Nome vem de quem abriu o modal (chave + data); o título é só reserva.
        link.setAttribute('download',
            nomeArquivo || `relatorio_${(titulo || 'relatorio').toLowerCase().replace(/\s+/g, '_')}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const abrirNovaGuia = () => { if (blobUrl) window.open(blobUrl, '_blank'); };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, flexGrow: 1 }}>
                    Relatório de {titulo}
                </Typography>
                <Tooltip title="Baixar PDF" arrow>
                    <span>
                        <IconButton onClick={baixar} disabled={!blobUrl} size="small"><DownloadIcon /></IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Abrir em nova guia" arrow>
                    <span>
                        <IconButton onClick={abrirNovaGuia} disabled={!blobUrl} size="small"><OpenInNewIcon /></IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Fechar" arrow>
                    <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
                </Tooltip>
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ minHeight: 0 }}>
                    <PdfFrame blobUrl={blobUrl} loading={loading} error={error} titulo={`Relatório de ${titulo}`} height="75vh" />
                </Box>
            </DialogContent>
        </Dialog>
    );
}
